import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, inrFormatter, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var Metric1 = chart.x1AxisDisplayName,
        Metric2 = chart.x2AxisDisplayName,
        Metric3 = chart.y1AxisDisplayName,
        Metric4 = chart.y2AxisDisplayName
    // Metric5 = chart.x1MetricTooltip

    // Create the svg area
    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    // loading api data
    axios.post(url, filterParam).then(res => {
        let data = res.data


        var radius = d3.scaleSqrt()
            .domain([0, d3.max(data, function (d) {
                return d.metric4
            })])
            .range([2, 5]);

        console.log("histogram", data, radius)
        // What are the numeric variables in this dataset? How many do I have
        var allVar = ['metric1', 'metric2', 'metric3', 'metric4']
        var numVar = allVar.length

        // Now I can compute the size of a single chart
        // vizSpecific1= 40
        let size;
        size = chart.width / numVar

        // Create a scale: gives the position of each pair each variable
        var position = d3.scalePoint().domain(allVar).range([0, chart.width - size])

        // Color scale: give me a specie name, I return a color
        var metric1ColorScale = d3.scaleOrdinal().domain(data.map(d => d.dim1_name))
            .range(fw_progressive_1way)


        // var metric1ColorScale = chart.vizSpecific4 == '4' ?
        //     d3.scaleOrdinal(circlePack) : d3.scaleOrdinal(fw_progressive_1way)


        // Add charts
        for (let i in allVar) {
            for (let j in allVar) {
                var var1 = allVar[i] // Get current variable name
                var var2 = allVar[j]

                // If var1 == var2 i'm on the diagonal, I skip that
                if (var1 === var2) {
                    continue
                }

                // Add Scale of each graph
                let x1AxisLabel = d3.extent(data, (d) => {
                    return +d[var1]
                })
                let y1AxisLabel = d3.extent(data, (d) => {
                    return +d[var2]
                })

                var x1Scale = d3.scaleLinear().domain(x1AxisLabel).nice().range([0, size - 2 * 40])
                var y1Scale = d3.scaleLinear().domain(y1AxisLabel).nice().range([size - 2 * 40, 0])

                // Add a 'g' at the right position
                var tmp = svg.append('g')
                    .attr('transform', 'translate(' + (position(var1) + 40) + ',' + (position(var2) + 40) + ')')

                // Add X and Y axis in tmp
                tmp.append('g')
                    .attr('transform', 'translate(' + 0 + ',' + (size - 40 * 2) + ')')
                    .call(d3.axisBottom(x1Scale).ticks(4).tickFormat(inrFormatter)).style('font-size', axisLabelFontSize)
                    .selectAll('text')
                    .style('text-anchor', 'end')
                    .attr('dx', '-.3em')
                    .attr('transform', 'rotate(-90)')

                tmp.append('g').call(d3.axisLeft(y1Scale).ticks(4).tickFormat(inrFormatter)).style('font-size', axisLabelFontSize)

                // var div= d3.select(divId).append('div').attr('class', 'tooltip').attr('style', 'position: absolute; opacity: 0;');
                // creating Tooltip
                /*    d3.select(".d3-tipmspc"+divId.id).remove(); // clear tooltip based on class of tip element
                    var y1tip = tooltip_class()

                    y1tip.attr('class', 'd3-tip'+divId.id)
                        .html(function (d) {
                            var metric2ColorScale = metric1ColorScale(d.dim1_name)
                            return d.dim1_name
                                + '<br>' + Metric1+ colonAnnotation +'<span style=\'color:' + metric2ColorScale + ';\'>' + inrFormatter(d.metric1) + '</span>'
                                + '<br>' + Metric2+ colonAnnotation +'<span style=\'color:' + metric2ColorScale + ';\'>' + inrFormatter(d.metric2) + '</span>'
                                + '<br>' + Metric3+ colonAnnotation +'<span style=\'color:' + metric2ColorScale + ';\'>' + inrFormatter(d.metric3) + '</span>'
                                + '<br>' + Metric4+ colonAnnotation +'<span style=\'color:' + metric2ColorScale + ';\'>' + inrFormatter(d.metric4)
                        })
                    svg.call(y1tip) */

                d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
                var div = d3.select(divId).append('div').attr('class', 'tooltip')
                    .attr('style', 'position: absolute; opacity: 0;')

                //  var histogram =['#FFFF00','#FF0000','#90EE90','#00FF00']


                // Add circle
                tmp.selectAll('myCircles')
                    .data(data)
                    .enter()
                    .append('circle')
                    .attr('cx', (d) => {
                        return x1Scale(+d[var1])
                    })
                    .attr('cy', (d) => {
                        return y1Scale(+d[var2])
                    })
                    .attr('r', chart.vizSpecific4 == 'fixedRadius' ? 2 : (d) => {
                        return radius(d.metric4)
                    })
                    // .attr('r', 2)
                    .attr('fill', (d) => { // Add the colours dynamically
                        return d.dim1_name.startsWith('1_C') ? "#00FF00" : d.dim1_name.startsWith('2_P') ? '#90EE90' : d.dim1_name.startsWith('3_L') ? "#FFFF00" : d.dim1_name.startsWith('4_I') ? "#FF0000" : metric1ColorScale(d.dim1_name)
                    })
                    .on("mousemove", function (d) {
                        console.log(d3.event, d)
                        div.transition()
                            .duration(200)
                            .style("opacity", .9);
                        // var metric2ColorScale = metric1ColorScale(d.dim1_name)
                        div.html(d.dim1_name
                            + '<br>' + Metric1 + colonAnnotation + inrFormatter(d.metric1)
                            + '<br>' + Metric2 + colonAnnotation + inrFormatter(d.metric2)
                            + '<br>' + Metric3 + colonAnnotation + inrFormatter(d.metric3)
                            + '<br>' + Metric4 + colonAnnotation + inrFormatter(d.metric4) + chart.vizSpecific5
                            // + '<br>' + Metric1+ colonAnnotation +'<span style=\'color:' + d.dim1_name.startsWith('1_C') ? "#00FF00" :  d.dim1_name.startsWith('2_P') ? '#90EE90' :  d.dim1_name.startsWith('3_L') ? "#FFFF00" : d.dim1_name.startsWith('4_I')  ? "#FF0000"  :  metric1ColorScale(d.dim1_name) + ';\'>' + inrFormatter(d.metric1) + '</span>'
                            // + '<br>' + Metric2+ colonAnnotation +'<span style=\'color:' + d.dim1_name.startsWith('1_C') ? "#00FF00" :  d.dim1_name.startsWith('2_P') ? '#90EE90' :  d.dim1_name.startsWith('3_L') ? "#FFFF00" : d.dim1_name.startsWith('4_I')  ? "#FF0000"  :  metric1ColorScale(d.dim1_name) + ';\'>' + inrFormatter(d.metric2) + '</span>'
                            // + '<br>' + Metric3+ colonAnnotation +'<span style=\'color:' + d.dim1_name.startsWith('1_C') ? "#00FF00" :  d.dim1_name.startsWith('2_P') ? '#90EE90' :  d.dim1_name.startsWith('3_L') ? "#FFFF00" : d.dim1_name.startsWith('4_I')  ? "#FF0000"  :  metric1ColorScale(d.dim1_name) + ';\'>' + inrFormatter(d.metric3) + '</span>'
                            // + '<br>' + Metric4+ colonAnnotation +'<span style=\'color:' + d.dim1_name.startsWith('1_C') ? "#00FF00" :  d.dim1_name.startsWith('2_P') ? '#90EE90' :  d.dim1_name.startsWith('3_L') ? "#FFFF00" : d.dim1_name.startsWith('4_I')  ? "#FF0000"  :  metric1ColorScale(d.dim1_name) + ';\'>' + inrFormatter(d.metric4) + chart.vizSpecific5 + '</span>'
                            // + '<br>' + Metric5 + colonAnnotation +'<span style=\'color:' + d.dim1_name.startsWith('1_C') ? "#00FF00" :  d.dim1_name.startsWith('2_P') ? '#90EE90' :  d.dim1_name.startsWith('3_L') ? "#FFFF00" : d.dim1_name.startsWith('4_I')  ? "#FF0000"  :  metric1ColorScale(d.dim1_name) + ';\'>' + inrFormatter(d.metric5) + '</span>'

                        )
                            .style("left", (d3.event.layerX) + "px")
                            .style("top", (d3.event.layerY) + "px");
                    })
                    .on("mouseout", function () {
                        div.transition().style("opacity", 0)
                    })
                //.on('mouseover', y1tip.show)
                //.on('mouseout', y1tip.hide)
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
            }
        }

        // Add histograms diagonal
        for (var i in allVar) {
            for (var j in allVar) {
                var1 = allVar[i]// variable names
                var2 = allVar[j]

                // If var1 == var2 i'm on the diagonal, otherwisee I skip
                if (i != j) {
                    continue
                }

                // create X Scale
                let x2AxisLabel;
                x2AxisLabel = d3.extent(data, (d) => {
                    return +d[var1]
                })
                x1Scale = d3.scaleLinear().domain(x2AxisLabel).nice().range([0, size - 2 * 40])

                // Add a 'g' at the right position
                tmp = svg.append('g')
                    .attr('transform', 'translate(' + (position(var1) + 40) + ',' + (position(var2) + 40) + ')')

                // Add x axis
                tmp.append('g')
                    .attr('transform', 'translate(' + 0 + ',' + (size - 40 * 2) + ')')
                    .call(d3.axisBottom(x1Scale).ticks(5).tickFormat(inrFormatter)).style('font-size', axisLabelFontSize)
                    .selectAll('text')
                    .style('text-anchor', 'end')
                    .attr('dx', '-.3em')
                    .attr('transform', 'rotate(-90)')

                //Add x1 axis label
                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 35)
                    .attr('x', chart.width / 10)
                    .style('fill', fontColor)
                    .text(Metric1)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 35)
                    .attr('x', chart.width / 3)
                    .style('fill', fontColor)
                    .text(Metric2)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 35)
                    .attr('x', chart.width / 1.6)
                    .style('fill', fontColor)
                    .text(Metric3)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 35)
                    .attr('x', chart.width / 1.15)
                    .style('fill', fontColor)
                    .text(Metric4)
                    .style('font-size', fontSize)

                //Add x2 axis label
                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 0 - chart.height)
                    .attr('x', chart.width / 10)
                    .style('fill', fontColor)
                    .text(Metric1)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 0 - chart.height)
                    .attr('x', chart.width / 3)
                    .style('fill', fontColor)
                    .text(Metric2)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 0 - chart.height)
                    .attr('x', chart.width / 1.6)
                    .style('fill', fontColor)
                    .text(Metric3)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'translate(0,' + chart.width + ')')
                    .attr('y', 0 - chart.height)
                    .attr('x', chart.width / 1.15)
                    .style('fill', fontColor)
                    .text(Metric4)
                    .style('font-size', fontSize)

                //	Add y axis label
                svg.append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', 0 - 40)
                    .attr('x', 0 - (chart.width / 4.7))
                    .style('fill', fontColor)
                    .text(Metric1)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', 0 - 40)
                    .attr('x', 0 - (chart.width / 2.5))
                    .style('fill', fontColor)
                    .text(Metric2)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', 0 - 40)
                    .attr('x', 0 - (chart.width / 1.5))
                    .style('fill', fontColor)
                    .text(Metric3)
                    .style('font-size', fontSize)

                svg.append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', 0 - 40)
                    .attr('x', 0 - (chart.width / 1.1))
                    .style('fill', fontColor)
                    .text(Metric4)
                    .style('font-size', fontSize)

                // set the parameters for the histogram. I need to give the vector of value
                var histogram = d3.histogram()
                    .value((d) => {
                        return +d[var1]
                    })
                    .domain(x1Scale.domain()).thresholds(x1Scale.ticks(10))

                // And apply this function to data to get the bins
                var bins = histogram(data)

                // Y axis: scale and draw:
                y1Scale = d3.scaleLinear()
                    .range([size - 2 * 40, 0])
                    .domain([0, d3.max(bins, (d) => {
                        return d.length
                    })])

                // append the bar rectangles to the svg element
                tmp.append('g')
                    .selectAll('rect')
                    .data(bins)
                    .enter()
                    .append('rect')
                    .attr('x', 1)
                    .attr('transform', (d) => {
                        return 'translate(' + x1Scale(d.x0) + ',' + y1Scale(d.length) + ')'
                    })
                    .attr('width', (d) => {
                        return x1Scale(d.x1) - x1Scale(d.x0)
                    })
                    .attr('height', (d) => {
                        return (size - 2 * 40) - y1Scale(d.length)
                    })
                    .style('fill', '#b8b8b8')
                    .attr('stroke', 'white')
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
            }
        }

        var sumstat = d3.nest()
            .key(d => {
                return d.dim1_name
            }).sortKeys(d3.ascending).entries(data)

        var y1legend = svg.append('g')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', (d, i) => 'translate(0,' + i * 25 + ')')

        y1legend.append('circle')
            .attr('cx', chart.width + chart.vizSpecific2 + 20)
            .attr('cy', 20)
            .attr('r', 7)
            .attr('dy', '0.75em')
            .attr('fill', d => {
                return d.key.startsWith('1_C') ? "#00FF00" : d.key.startsWith('2_P') ? '#90EE90' : d.key.startsWith('3_L') ? "#FFFF00" : d.key.startsWith('4_I') ? "#FF0000" : metric1ColorScale(d.key)
            })

        y1legend.append('text')
            .data(sumstat, d => {
                return d.key
            })
            .attr('x', chart.width + chart.vizSpecific2 + 32)
            .attr('y', 10)
            .attr('dy', '1em')
            .text(d => {
                return d.key
            })
            .style('font-size', axisLabelFontSize)
    })
}
